var DateInput = (function (useValidation, minYearOffset, ageOffset) {
    var $input;
    var _eventHandler = $({});

    useValidation = useValidation || false;
    ageOffset = ageOffset || 0;
    minYearOffset = minYearOffset || 159;

    var __delimiter = '/';
    var __maskDelimeter = '/';
    var _mask = 'dd' + __maskDelimeter + 'mm' + __maskDelimeter + 'yyyy';
    var _dayPosition = {
        start: _mask.indexOf('dd'),
        end: _mask.indexOf('dd') + 2,
        min: 0,
        max: _mask.indexOf(__delimiter)
    }
    var _monthPosition = {
        start: _mask.indexOf('mm'),
        end: _mask.indexOf('mm') + 2,
        min: _mask.indexOf(__delimiter) + 1,
        max: _mask.lastIndexOf(__delimiter)
    }
    var _yearPosition = {
        start: _mask.indexOf('yyyy'),
        end: _mask.indexOf('yyyy') + 4,
        min: _mask.lastIndexOf(__delimiter) + 1,
        max: _mask.length
    }

    var currentYear = new Date().getFullYear();
    var minYear = currentYear - minYearOffset;

    var _dayValueStr = null, _monthValueStr = null, _yearValueStr = null;

    var _date = {
        day: null,
        month: null,
        year: null,
        getDate: function () {
            if (this.day !== null && this.month !== null && this.year !== null && this.day !== undefined && this.undefined !== null && this.undefined !== null) {
                return new Date(this.year, this.month - 1, this.day);
            }
            return null;
        }
    };

    var types = {
        day: _dayPosition.max,
        month: _monthPosition.max,
        year: _yearPosition.max
    };

    var keys = {
        ArrowLeft: 'ArrowLeft',
        ArrowUp: 'ArrowUp',
        ArrowRight: 'ArrowRight',
        ArrowDown: 'ArrowDown',
        Backspace: 'Backspace',
        Delete: 'Delete',
        Enter: 'Enter'
    };

    var selected = null;

    /* system functions */
    function setInputSelection(el, startPos, endPos) {
        //return;
        el.focus();
        endPos = startPos;
        if (typeof el.selectionStart != "undefined") {
            el.selectionStart = startPos;
            el.selectionEnd = endPos;
        } else if (document.selection && document.selection.createRange) {
            // IE branch
            el.select();
            var range = document.selection.createRange();
            range.collapse(true);
            range.moveEnd("character", endPos);
            range.moveStart("character", startPos);
            range.select();
        }
    }

    var getSelectionStart = function (el) {
        if (el.createTextRange && document.selection) {
            var r = document.selection.createRange().duplicate();
            r.moveEnd('character', el.value.length);
            if (r.text == '')
                return el.value.length;
            return el.value.lastIndexOf(r.text);
        } else return el.selectionStart;
    };

    var getKey = function (e) {
        var code = null;
        if (e.type === 'keydown') {
            if (e.key) {
                return e.key;
            }
            code = e.keyCode || e.which;
        } else if (e.type === 'input' && e.originalEvent && e.originalEvent.data && e.originalEvent.data.charCodeAt) {
            code = e.originalEvent.data.charCodeAt(0);
        }

        if (code === 37) {
            return keys.ArrowLeft;
        }
        if (code === 38) {
            return keys.ArrowUp;
        }
        if (code === 39) {
            return keys.ArrowRight;
        }
        if (code === 40) {
            return keys.ArrowDown;
        }
        if (code === 8) {
            return keys.Backspace;
        }
        if (code === 46) {
            return keys.Delete;
        }
        if (code === 13) {
            return keys.Enter;
        }

        if (code === 48 || code === 96 && e.type === 'keydown') {
            return '0';
        }
        if (code === 49 || code === 97 && e.type === 'keydown') {
            return '1';
        }
        if (code === 50 || code === 98 && e.type === 'keydown') {
            return '2';
        }
        if (code === 51 || code === 99 && e.type === 'keydown') {
            return '3';
        }
        if (code === 52 || code === 100 && e.type === 'keydown') {
            return '4';
        }
        if (code === 53 || code === 101 && e.type === 'keydown') {
            return '5';
        }
        if (code === 54 || code === 102 && e.type === 'keydown') {
            return '6';
        }
        if (code === 55 || code === 103 && e.type === 'keydown') {
            return '7';
        }
        if (code === 56 || code === 104 && e.type === 'keydown') {
            return '8';
        }
        if (code === 57 || code === 105 && e.type === 'keydown') {
            return '9';
        }
        return null;

    };

    var setSelected = function (el, pos) {
        pos = pos || selected || getSelectionStart(el) || 0;

        var start;
        var length;

        if (pos >= _dayPosition.min && pos <= _dayPosition.max) {
            start = _dayPosition.start;
            end = _dayPosition.end;
            length = !_dayValueStr ? 0 : _dayValueStr.length;
            selected = types.day;
        } else if (pos >= _monthPosition.min && pos <= _monthPosition.max) {
            start = _monthPosition.start;
            end = _monthPosition.end;
            length = !_monthValueStr ? 0 : _monthValueStr.length;
            selected = types.month;
        } else {
            start = _yearPosition.start;
            end = _yearPosition.end;
            length = !_yearValueStr ? 0 : _yearValueStr.length;
            selected = types.year;
        }
        updateDate(el);
        setInputSelection(el, start + length, start + length);
        _eventHandler.trigger('changeSelected', selected);
    };

    var updateDate = function (el) {
        var value = '';
        var _day;
        var _month;
        var _year;

        if (selected == types.day) {
            var v = _dayValueStr;
            if (v === null) {
                _day = '__';
            } else {
                _day = v.toString().replace(/^(\d)$/, '$1_');
            }
        } else {
            if (_dayValueStr === null) {
                _day = 'dd';
            } else {
                _day = _dayValueStr.replace(/^(\d)$/, '0$1');
            }
        }

        if (selected == types.month) {
            var v = _monthValueStr;
            if (v === null) {
                _month = '__';
            } else {
                _month = v.toString().replace(/^(\d)$/, '$1_');
            }
        } else {
            if (_monthValueStr === null) {
                _month = 'mm';
            } else {
                _month = _monthValueStr.replace(/^(\d)$/, '0$1');
            }
        }

        if (selected == types.year) {
            var v = _yearValueStr;
            if (v === null) {
                _year = '____';
            } else {
                _year = v
                    .replace(/^(\d)$/, '$1___')
                    .replace(/^(\d\d)$/, '$1__')
                    .replace(/^(\d\d\d)$/, '$1_');
            }
        } else {
            if (_yearValueStr === null) {
                _year = 'yyyy';
            } else {
                _year = _yearValueStr
                    .replace(/^(\d)$/, '$1___')
                    .replace(/^(\d\d)$/, '$1__')
                    .replace(/^(\d\d\d)$/, '$1_');
            }
        }

        var value = _mask.replace('dd', _day)
            .replace('mm', _month)
            .replace('yyyy', _year);
        el.value = value;
    };

    var setNextSelected = function (el) {
        if (selected === types.day) {
            setSelected(el, types.month);
        } else if (selected === types.month) {
            setSelected(el, types.year);
        } else if (selected === types.year) {
        }
    };
    var setPrevSelected = function (el) {
        if (selected === types.day) {
        } else if (selected === types.month) {
            setSelected(el, types.day);
        } else if (selected === types.year) {
            setSelected(el, types.month);
        }
    };

    var _getSelectedDate = function () {
        if (!useValidation) {
            return _date.getDate();
        } else if (_date.year >= minYear && _date.year <= currentYear) {
            return _date.getDate();
        } else {
            return null;
        }
    };

    var _setDay = function (value) {
        if (value !== null && value > 31) value = 1;
        if (value !== null && value <= 0) value = 31;
        _date.day = value || null;       
        _eventHandler.trigger('changeDate');
        return _date.day;
    };

    var _setMonth = function (value) {
        if (value !== null && value > 12) value = 1;
        if (value !== null && value <= 0) value = 12;
        _date.month = value || null;
        _eventHandler.trigger('changeDate');
        return _date.month;
    };

    var _setYear = function (value) {
        if (useValidation && value !== null && value >= 1000) {
            if (value > currentYear) value = minYear;
            if (value < minYear) value = currentYear;
        }
        _date.year = value || null;
        _eventHandler.trigger('changeDate');
        return _date.year;
    };

    var _addDay = function (value) {
        var day = (_date.day || 0) + value;
        var v = _setDay(day);
        _dayValueStr = v === null ? null : v.toString().replace(/^(\d)$/, '0$1'); 
    }

    var _addMonth = function (value) {
        var month = (_date.month || 0) + value;
        var v = _setMonth(month);
        _monthValueStr = v === null ? null : v.toString().replace(/^(\d)$/, '0$1'); 
    }

    var _addYear = function (value) {
        var year = (_date.year || currentYear - ageOffset) + value;
        var v = _setYear(year);
        _yearValueStr = v === null ? null : v.toString(); 
    }

    var increase = function (el) {
        if (selected === types.day) {
            _addDay(1);
        } else if (selected === types.month) {
            _addMonth(1);
        } else if (selected === types.year) {
            _addYear(1);
        }

        setSelected(el);
    };
    var decrease = function (el) {
        if (selected === types.day) {
            _addDay(-1);
        } else if (selected === types.month) {
            _addMonth(-1);
        } else if (selected === types.year) {
            _addYear(-1);
        }

        setSelected(el);
    };

    var _backspace = function (str) {
        var v = str || "";
        str = v.substring(0, v.length - 1) || null;
        return {
            str: str,
            int: parseInt(str) || null
        };
    };
    var backspace = function (el) {
        var value;
        var type;
        if (selected === types.day) {
            value = _backspace(_dayValueStr);
            _dayValueStr = value.str;
            _setDay(value.int);
        } else if (selected === types.month) {
            _monthValueStr === null && (type = types.day) || (type = types.month);
            value = _backspace(_monthValueStr);
            _monthValueStr = value.str;
            _setMonth(value.int);
        } else if (selected === types.year) {
            _yearValueStr === null && (type = types.month) || (type = types.year);
            value = _backspace(_yearValueStr);
            _yearValueStr = value.str;
            _setYear(value.int);
        }

        setSelected(el, type);
    };

    var enter = function (el) {
        $input.blur();
        _eventHandler.trigger('close');
    };


    var setDay = function (el, value) {
        if (_dayValueStr === null) {
            if (value > 3) {
                _dayValueStr = "0" + value.toString();
                setNextSelected(el); // >>>
            } else {
                _dayValueStr = value.toString();
            }
        } else if (_dayValueStr.length < 2 && (_dayValueStr !== "0" || value > 0)) {
            var d = _dayValueStr + '' + value;
            value = parseInt(d);
            if (value > 31) {
                value = 31;
                _dayValueStr = "31";
            } else {
                _dayValueStr = d;
            }
            setNextSelected(el); // >>>
        } else if (_dayValueStr.length === 2 && _dayValueStr.startsWith('0')) {
            var d = _dayValueStr.slice(1) + '' + value;
            value = parseInt(d);
            if (value > 31) {
                value = 31;
                _dayValueStr = "31";
            } else {
                _dayValueStr = d;
            }
            setNextSelected(el); // >>>
        } else {
            value = 0;
        }
        value !== 0 && _setDay(value);
        setSelected(el);
    };
    var setMonth = function (el, value) {
        if (_monthValueStr === null) {
            if (value > 1) {
                _monthValueStr = "0" + value.toString();
                setNextSelected(el); // >>>
            } else {
                _monthValueStr = value.toString();
            }
        } else if (_monthValueStr.length < 2 && (_monthValueStr !== "0" || value > 0)) {
            var m = _monthValueStr + '' + value;
            value = parseInt(m);
            if (value > 12) {
                value = 12;
                _monthValueStr = "12";
            } else {
                _monthValueStr = m;
            }
            setNextSelected(el); // >>>
        } else if (_monthValueStr.length === 2 && _monthValueStr.startsWith('0')) {
            var m = _monthValueStr.slice(1) + '' + value;
            value = parseInt(m);
            if (value > 12) {
                value = 12;
                _monthValueStr = "12";
            } else {
                _monthValueStr = m;
            }
            setNextSelected(el); // >>>
        } else {
            value = 0;
        }
        value !== 0 && _setMonth(value);
        setSelected(el);
    };
    var setYear = function (el, value) {
        if (_yearValueStr === null) {
            if (value === 1 || value === 2) {
                _yearValueStr = value.toString();
            } else {
                value = null;
            }
        } else if (_yearValueStr.length === 1) {
            if (_yearValueStr === '2' && value === 0 ||
                _yearValueStr === '1' && (value === 8 || value === 9)) {
                _yearValueStr = _yearValueStr + '' + value;
                value = parseInt(_yearValueStr);
            }
        } else if (_yearValueStr.length <= 3) {
            _yearValueStr = _yearValueStr + '' + value;
            value = parseInt(_yearValueStr);
        }
        else {
            value = parseInt(_yearValueStr);
        }
        _setYear(value);
        setSelected(el);
    };

    var _focusSelectedType = null;

    /* main functions */
    var handleFocus = function () {
        var el = $(this)[0];

        var type = types.year;

        if (_date.day === null) {
            type = types.day;
        } else if (_date.month === null) {
            type = types.month;
        } else if (_date.year === null || _date.year.toString().length < 4) {
            type = types.year;
        } else {
            type = types.day;
        }

        selected = type;
        _focusSelectedType = type;
        setTimeout(function () {
            setSelected(el);
        }, 0);
    };

    var handleBlur = function () {
        var el = $(this)[0];
        var currentDate = _getSelectedDate();
        if (currentDate !== null) {
            _eventHandler.trigger('changeDate');
        }
        selected = null;
        updateDate(el);
    };

    var handleCursor = function () {
        var el = $(this)[0];
        if (_focusSelectedType !== null) {
            selected = _focusSelectedType;
            _focusSelectedType = null;
        } else {
            selected = null;
        }
        setTimeout(function () {
            setSelected(el);
        }, 0);
    };

    var handleWheel = function (e) {
        var delta = e.deltaY || e.detail || e.wheelDelta;
        if (delta > 0) {
            decrease(e.target);
        } else {
            increase(e.target);
        }
        e && e.preventDefault();
    };

    var subscribeWheel = function (el) {
        if (el.addEventListener) {
            if ('onwheel' in document) {
                // IE9+, FF17+, Ch31+
                el.addEventListener("wheel", handleWheel);
            } else if ('onmousewheel' in document) {
                // устаревший вариант события
                el.addEventListener("mousewheel", handleWheel);
            } else {
                // Firefox < 17
                el.addEventListener("MozMousePixelScroll", handleWheel);
            }
        } else { // IE8-
            el.attachEvent("onmousewheel", handleWheel);
        }
    };

    var _validate = function () {
        if (!useValidation) return true;
        var currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59);
        var controlTime = currentDate.setYear(currentDate.getFullYear() - ageOffset);
        var selectedDate = _getSelectedDate();
        var isValid = selectedDate && selectedDate.getTime() < controlTime;
        $input.toggleClass('invalid', !isValid);
        return isValid;
    };

    var KeyHandler = function (handleControlKeys, handleDigitKeys) {
        return function(e) {
            var key = getKey(e);
            var el = $(this)[0];

            if (handleControlKeys) {
                if (key === keys.ArrowLeft) setPrevSelected(el);
                if (key === keys.ArrowRight) setNextSelected(el);

                if (key === keys.ArrowUp) increase(el);
                if (key === keys.ArrowDown) decrease(el);

                if (key === keys.Backspace) backspace(el);
                if (key === keys.Delete) backspace(el);

                if (key === keys.Enter) enter(el);
            }

            if (handleDigitKeys) {
                if (key === "0" || key === "1" || key === "2" || key === "3" || key === "4" || key === "5" || key === "6" || key === "7" || key === "8" || key === "9") {
                    var value = parseInt(key);
                    if (selected === types.day) setDay(el, value);
                    else if (selected === types.month) setMonth(el, value);
                    else if (selected === types.year) setYear(el, value);
                }
            }

            return false;
        }
    }

    var initForFF = function ($input) {

        $input.prop('type', 'date');

        window.dd = $input;

        $input.on('change', function (e) {
            var input = e && e.currentTarget;
            if (input && input.valueAsDate) {
                var d = input.valueAsDate;
                $.extend(_date, {
                    day: d.getDate(),
                    month: d.getMonth() + 1,
                    year: d.getFullYear()
                });
                _eventHandler.trigger('changeDate');
            }
        });

        $input.on('input', function (e) {
            var input = e && e.currentTarget;
            if (!input || !input.valueAsDate) {
                $.extend(_date, {
                    day: null,
                    month: null,
                    year: null
                });
                _eventHandler.trigger('changeDate');
            }
        });
    }

    var isAndroid = !!navigator.userAgent.match(/Android/i);
    var isFirefox = !!navigator.userAgent.match(/Firefox/i);
    var _useNativeFF;

    return {
        init: function (input, useNativeFF) {
            $input = input;
            _useNativeFF = useNativeFF;

            if (isAndroid && isFirefox) {

                if (useNativeFF) {
                    initForFF($input);
                    return true;
                } else {
                    $input.attr('readonly', true);
                    $input.val(_mask);
                }

                return false;
            }

            if (isAndroid) {
                $input.on('keydown', KeyHandler(true, false));
                $input.on('input', KeyHandler(false, true));
            } else {
                $input.on('keydown', KeyHandler(true, true));
            }

            $input.on('click', handleCursor);
            $input.on('focus', handleFocus);
            $input.on('blur', handleBlur);
            subscribeWheel($input[0]);
            updateDate($input[0]);

            return true;
        },
        setDate: function (d) {

            d.day = d.day || null;
            d.month = d.month || null;
            d.year = d.year || null;

            $.extend(_date, d);

            if (isAndroid && isFirefox && _useNativeFF) {
                if ($input && $input[0]) {
                    $input[0].value = d.year + '-' + d.month + '-' + d.day;
                }
            } else {
                _dayValueStr = d.day === null ? null : d.day.toString().replace(/^(\d)$/, '0$1');
                _monthValueStr = d.month === null ? null : d.month.toString().replace(/^(\d)$/, '0$1');
                _yearValueStr = d.year === null ? null : d.year.toString();
                updateDate($input[0]);
                _validate();
            }
        },
        onChange: function (func) {
            _eventHandler.on('changeDate', function (e) {
                var isValid = _validate();
                var selectedDate = _getSelectedDate();
                if (useValidation) {
                    func(isValid, selectedDate, _date);
                } else {
                    func(true, selectedDate, _date);
                }
            });
        },
        onChangeSelected: function (setDayActive, setMonthActive, setYearActive) {
            _eventHandler.on('changeSelected', function (e, selected) {
                if (selected === types.day) setDayActive();
                if (selected === types.month) setMonthActive();
                if (selected === types.year) setYearActive();
            });
        },
        onClose: function (func) {
            _eventHandler.on('close', function () {
                _validate();
                func();
            });
        }
    };
});
